import { render, staticRenderFns } from "./MasqueradeExtension.vue?vue&type=template&id=3b8c2d2b&"
import script from "./MasqueradeExtension.vue?vue&type=script&lang=ts&"
export * from "./MasqueradeExtension.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports